<template>
  <div class="impressao-dados-linha">
    <div v-show="impressaoMostraRem" class="impressao-dados-coluna impressao-dados-divide-pagina-a">
      <h2 class="impressao-dados-rem-des">Remetente</h2>
      <div class="impressao-dados-coluna">
        <ImpressaoBloco
          v-if="
            !(
              dadosCenario.cnpjRem == '' ||
              dadosCenario.cnpjRem == undefined ||
              !dadosCenario.mostraRem
            )
          "
          :nome="'CNPJ:'"
          :dado="dadosCenario.cnpjRem"
        />
        <ImpressaoBloco v-if="dadosCenario.cnaeRem" :nome="'CNAE:'" :dado="dadosCenario.cnaeRem" />
        <ImpressaoBloco
          v-if="dadosCenario.mostraAtividadeRem"
          :nome="'Atividade:'"
          :dado="dadosCenario.atividadeRem"
        />
        <ImpressaoBloco
          v-if="dadosCenario.mostraTipoAtividadeRem"
          :nome="'Tipo de Atividade:'"
          :dado="dadosCenario.tipoAtividadeRem"
        />

        <div v-if="dadosCenario.mostraRegimeRem" class="impressao-bloco">
          <h3>Regime Tributário:</h3>
          <p>{{ dadosCenario.regimeRem }}</p>
          <div class="impressao-dados-coluna">
            <div
              v-if="dadosCenario.receitaBruta != 'R$ 0,00'"
              class="impressao-dados-linha impressao-receita"
            >
              <h3>
                Receita bruta (12 meses):
              </h3>
              <p>{{ dadosCenario.receitaBruta }}</p>
            </div>
            <div
              v-if="dadosCenario.receitaAcumulada != 'R$ 0,00'"
              class="impressao-dados-linha impressao-receita"
            >
              <h3>
                Receita Acumulada (Ano-calendário):
              </h3>
              <p>{{ dadosCenario.receitaAcumulada }}</p>
            </div>
            <div
              v-if="dadosCenario.receitaMes != 'R$ 0,00'"
              class="impressao-dados-linha impressao-receita"
            >
              <h3>
                Receita do Mês (Mês corrente):
              </h3>
              <p>{{ dadosCenario.receitaMes }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="impressaoMostraDes" class="impressao-dados-coluna impressao-dados-divide-pagina-b">
      <h2 class="impressao-dados-rem-des">Destinatário</h2>
      <div class="impressao-dados-coluna">
        <ImpressaoBloco
          v-if="!(dadosCenario.cnpjDes == '' || dadosCenario.cnpjDes == undefined)"
          :nome="'CNPJ:'"
          :dado="dadosCenario.cnpjDes"
        />
        <ImpressaoBloco v-if="dadosCenario.cnaeDes" :nome="'CNAE:'" :dado="dadosCenario.cnaeDes" />
        <ImpressaoBloco
          v-if="dadosCenario.mostraAtividadeDes"
          :nome="'Atividade:'"
          :dado="dadosCenario.atividadeDes"
        />
        <ImpressaoBloco
          v-if="dadosCenario.mostraTipoAtividadeDes"
          :nome="'Tipo de Atividade:'"
          :dado="dadosCenario.tipoAtividadeDes"
        />
        <ImpressaoBloco
          v-if="dadosCenario.mostraRegimeDes"
          :nome="'Regime Tributário:'"
          :dado="dadosCenario.regimeDes"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImpressaoBloco from "./ImpressaoBloco.vue";

export default {
  name: "ImpressaoRemDes",
  components: { ImpressaoBloco },
  props: {
    dadosCenario: Array | Object,
    impressaoMostraRem: Boolean,
    impressaoMostraDes: Boolean
  }
};
</script>

<style lang="scss" scoped>
.impressao-dados-coluna {
  display: flex;
  flex-direction: column;
  h2 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 14px;
    font-weight: bold;
  }
  h4 {
    font-size: 12px;
    font-weight: bold;
  }

}
.impressao-dados-linha {
  display: flex;
  flex-direction: row;
}
.impressao-dados-divide-pagina-a {
  width: 60%;
}
.impressao-dados-divide-pagina-b {
  width: 40%;
}
.impressao-dados-rem-des {
  margin-bottom: 20px;
}
.impressao-receita {
  height: fit-content;
  h3 {
    margin-right: 15px;
    height: fit-content;
    margin-bottom: 5px;
  }
  p {
    margin-bottom: 5px;
  }
}

</style>
